import type { SearchSchemaInput } from "@tanstack/react-router"

export const RUN_PAGE_TAB = {
  products: "products",
  workflow: "workflow",
} as const
export type RunPageTab = (typeof RUN_PAGE_TAB)[keyof typeof RUN_PAGE_TAB]

export function validateRunPageSearch(search: SearchSchemaInput & { tab?: unknown }): {
  tab: RunPageTab
} {
  return {
    tab: search.tab === RUN_PAGE_TAB.workflow ? RUN_PAGE_TAB.workflow : RUN_PAGE_TAB.products,
  }
}
